import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const CreateHealthInsurances = () => {
  return (
    <Create
      title="Създаване на здравнa осигуровка"
      actions={<BackButtonToolbar />} >
      <SimpleForm>
        <SaveForm isCreating={true}/>
      </SimpleForm>
    </Create>
  );
};

export default CreateHealthInsurances;
